import { Avatar, Stack, Typography } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { BenefitsIcon } from 'Images';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.LongtermEquipment);
  const isDesktop = useIsDesktop();

  return (
    <Stack flexDirection={'row'}>
      <Stack gap={isDesktop ? '16px' : '8px'}>
        <Typography
          mt={isDesktop ? undefined : 2}
          variant={'h2'}
          color={'text.secondary'}
          component={'h1'}
        >
          {dictionary.title}
        </Typography>
        <Typography variant={'body3'} color={'text.secondary'}>
          {dictionary.subtitle}
        </Typography>
        <LinkArrowLeft2
          href={dictionary.equipmentLinkUrl}
          text={dictionary.equipmentLinkLabel}
          newWindow={false}
          variant={'body3'}
        />
      </Stack>
      {isDesktop && (
        <Avatar
          alt=''
          src={BenefitsIcon}
          sx={{ width: '160px', height: '149px' }}
        />
      )}
    </Stack>
  );
};
